export const CONTENT_BLOCK_DOCUMENT = "content-block-document";
export const CONTENT_BLOCK_HTML = "content-block-html";